import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import config from '../../config.json';

interface ColorPaletteContextProps {
  colorPalette: string;
  setColorPalette: (palette: string) => void;
}

const ColorPaletteContext = createContext<ColorPaletteContextProps | undefined>(
  undefined
);

export function ColorPaletteProvider({ children }: { children?: ReactNode }) {
  const [colorPalette, setColorPalette] = useState(config.colorPalette); // Initial color palette

  useEffect(() => {
    //console.log('Color Palette: ', colorPalette);
  }, [colorPalette])

  return (
    <ColorPaletteContext.Provider value={{ colorPalette, setColorPalette }}>
      {children}
    </ColorPaletteContext.Provider>
  );
}

export function useColorPalette() {
  const context = useContext(ColorPaletteContext);
  if (!context) {
    throw new Error(
      'useColorPalette must be used within a ColorPaletteProvider'
    );
  }
  return context;
}
